__webpack_require__.p = "https://images-cdn-staging.curipod.com/d-d484f045/_next/";